export default function copyToClipboard(str, callback) {
    if (navigator.clipboard) {
        navigator.clipboard.writeText(str).then(() => callback())
    }
}